/* Kratus × Eclipse — pill sticky flotante "Filtrar | Orden" de la colección. [E4.2, E5]
   El segmento "Filtrar" NO reimplementa el panel: Dawn ya trae un drawer (filter_type
   'drawer') detrás de un <details>/<summary> nativo
   (.mobile-facets__wrapper .mobile-facets__disclosure > summary). Este script solo dispara
   ese trigger real por click programático — mismo patrón de "no tocar la lógica nativa" que
   pdp-eclipse.js usa para acordeones.

   [E5] El segmento "Orden" ya NO vive aquí: desde que el panel separa filtrar/ordenar, el
   botón sticky de orden lleva data-eclipse-sort-trigger y lo maneja
   collection-sort-popover-eclipse.js (el mismo popover que dispara el control de arriba). Este
   archivo solo conserva el trigger del panel de filtros.

   Delegación 100% en document (igual que related-products-eclipse.js): el contenido de facets
   se re-renderiza por AJAX en cada filtrado/ordenado (facets.js reemplaza el DOM del grid+drawer
   sin recargar la página), así que un bind directo a los botones se perdería tras el primer
   filtro aplicado. */
(function () {
  if (window.__eclipseCollectionControlsBound) {
    return;
  }
  window.__eclipseCollectionControlsBound = true;

  function abrirDrawer() {
    var summary = document.querySelector('.facets-container-drawer .mobile-facets__disclosure > summary');
    if (!summary) {
      return null;
    }
    var details = summary.closest('details');
    if (details && !details.hasAttribute('open')) {
      summary.click();
    }
    return details;
  }

  document.addEventListener('click', function (event) {
    if (event.target.closest('[data-eclipse-sticky-filters]')) {
      abrirDrawer();
    }
  });
})();
